"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Content;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../../elements/other/headline-lockup/index.js"));
var _logoItem = _interopRequireDefault(require("./logo-item"));
/**
 * Local Imports
 */

const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h1bngp7d"
});
const LogoContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "LogoContainer",
  class: "pl-ltwa2ku"
});

/**
 * Content Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Logo items
 * @param {String} props.columnType Type of column layout
 * @returns {React.ReactElement} Content Component
 * @public
 */

function Content({
  items,
  columnType,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, /*#__PURE__*/_react.default.createElement(_index.default, rest)), items && /*#__PURE__*/_react.default.createElement(LogoContainer, {
    "data-column": columnType,
    "data-cy": "logo-container"
  }, items?.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(_logoItem.default, (0, _extends2.default)({
      key: idx,
      image: item.browserImage
    }, item));
  })));
}
Content.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_logoItem.default.propTypes)),
  columnType: _propTypes.default.oneOf(['max-6', 'max-5'])
};